import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.businessCardDetails
)

export const selectBusinessCard = createSelector(
    baseSelector,
    (state) => state.card
)

export const selectBusinessCardTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)

export const selectBusinessCardTransactionDetails = createSelector(
    baseSelector,
    (state) => state.transactionDetails
)

export const selectBusinessCardLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectBusinessCardFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectBusinessCardError = createSelector(
    baseSelector,
    (state) => state.error
)

export const selectBusinessCardPage = createSelector(
    baseSelector,
    (state) => state.page
)

export const selectBusinessCardTotalPages = createSelector(
    baseSelector,
    (state) => state.totalPages
)

